import { render, staticRenderFns } from "./NetTest.vue?vue&type=template&id=40224acb&scoped=true"
import script from "./NetTest.vue?vue&type=script&lang=js"
export * from "./NetTest.vue?vue&type=script&lang=js"
import style0 from "./NetTest.vue?vue&type=style&index=0&id=40224acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40224acb",
  null
  
)

export default component.exports